import { render, staticRenderFns } from "./updateSubrole.vue?vue&type=template&id=13669d6c&scoped=true"
import script from "./updateSubrole.vue?vue&type=script&lang=js"
export * from "./updateSubrole.vue?vue&type=script&lang=js"
import style0 from "./updateSubrole.vue?vue&type=style&index=0&id=13669d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13669d6c",
  null
  
)

export default component.exports